import { Badge } from "../Badge";
import cx from "classnames";

export type AwardCardProps = { name: string; description: string; years?: string[] | number[]; highlight?: boolean; icon?: string };

export function AwardCard({ name, description, years, highlight, icon }: AwardCardProps) {
  return (
    <div className='h-full'>
      <a className='hover-3d h-full w-full'>
        {/* content */}
        <figure
          className={cx("rounded-xl border border-gray-300 bg-base-100 h-full", {
            "border-secondary transition-all hover:shadow-sm shadow-secondary duration-initial": highlight,
          })}
        >
          <div className='p-6 flex flex-col justify-between grow h-full'>
            <div className='flex justify-between items-start'>
              <div>
                <h5 className='text-xl font-semibold mb-2'>{name}</h5>
                <p className='text-base-content/90'>{description}</p>
              </div>
              {years && years.length > 1 && !highlight && <div className='rounded-full font-semibold text-primary pl-2'>x{years.length}</div>}
            </div>
            <div className='flex justify-between'>
              <div>
                {years &&
                  years.map((year, index) => (
                    <Badge key={index} text={year.toString()} className={cx("text-xs text-primary mr-2 mt-4", { "text-secondary": highlight })} />
                  ))}
              </div>
              <div className='flex items-end'>{icon && <img src={icon} className='h-5' />}</div>
            </div>
          </div>
        </figure>
        {/* 8 empty divs needed for the 3D effect */}
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </a>
    </div>
  );
}
